window.visibleTariffBlock = function() {
    let tariffBlock =  document.querySelector("#choose-tariff");
    let targetPosition = {
        top: window.pageYOffset + tariffBlock.getBoundingClientRect().top,
        bottom: window.pageYOffset + tariffBlock.getBoundingClientRect().bottom
    },

    windowPosition = {
        top: window.pageYOffset,
        bottom: window.pageYOffset + document.documentElement.clientHeight
    };

    if (targetPosition.top < (windowPosition.bottom + windowPosition.top) ) {
        tariffBlock.classList.add("show");
    } else if (targetPosition.top > windowPosition.bottom) {
        tariffBlock.classList.remove("show");
    }
}

window.readyKtkPage = function() {
    sal();
    visibleTariffBlock();
    document.addEventListener("scroll", function() {
        visibleTariffBlock();
    });
};
